var map = {
	"./tourimg-1.png": "8R5V",
	"./tourimg-2.png": "hy3A",
	"./tourimg-3.png": "ZD3R",
	"./tourimg-4.png": "tEPa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DOyP";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list ^\.\/tourimg\-.*\.png$
// module id = DOyP
// module chunks = 1